import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    "headerInput",
    "reveal",
    "submit"
  ]

  connect () {
    this.setupFormEventHandling()
    this.setupStarsChangedHandling()
  }

  placeholderUpdate (details) {
    const headerInput = this.headerInputTarget
    const value = details.value


    if (value && value > 0) {
      this.revealTarget.classList.remove('d-none');
      headerInput.textContent = details.headerPlaceholder;
    }
  }

  setupFormEventHandling () {
    const form = this.element
    const submit = this.submitTarget

    form.addEventListener('ajax:beforeSend', (_event) => {
      submit.setAttribute('disabled', true);
    })

    form.addEventListener('ajax:success', (event) => {
      const xhr = event.detail[2]
      form.outerHTML = xhr.responseText;

      if (typeof(ga) != 'undefined') {
        ga(['send', 'pageview', '/reviews/create']);
      }
    })

    form.addEventListener('ajax:error', (event) => {
      const xhr = event.detail[2]
      form.outerHTML = xhr.responseText;
    })

    form.addEventListener('ajax:complete', (event) => {
      submit.removeAttribute('disabled');
    })
  }

  setupStarsChangedHandling () {
    const placeHolderUpdate = this.placeholderUpdate.bind(this)

    window.addEventListener('stars.value-changed', function(event) {
      placeHolderUpdate(event.detail)
    });
  }
}
